import React from "react";

export default function WalletAlertsPanel({ alerts }) {
  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="wallet-alerts">
      <h3 className="wallet-alerts-title">Wallet Diagnostics</h3>
      <p className="wallet-alerts-disclaimer">
         These diagnostics are read-only observations of public blockchain data.
         This app does not initiate transactions, modify wallet settings, or interact with your funds.
    </p>

      {alerts.map((alert) => {
        const isDetected = alert.detected === true;

        return (
          <div
            key={alert.id}
            className={`wallet-alert-card ${
              isDetected ? "alert-detected" : "alert-clear"
            }`}
          >
            {/* Header */}
            <div className="wallet-alert-header">
              <span className="alert-icon">
                {isDetected ? "⚠️" : "✅"}
              </span>
              <span className="alert-check-title">
                {alert.title}
              </span>
            </div>

            {/* Status */}
            <div
              className={`alert-status ${
                isDetected ? "status-warning" : "status-ok"
              }`}
            >
              {isDetected ? "Status: Attention needed" : "Status: All clear"}
            </div>

            {/* Message */}
            <p className="alert-message">
              {isDetected
                ? alert.message
                : "No issues were detected for this check."}
            </p>

            {/* Reassurance */}
            {alert.reassurance && (
              <p className="alert-reassurance">
                ℹ️ {alert.reassurance}
              </p>
            )}

            {/* Meta */}
            <div className="alert-meta">
              Risk: <strong>{alert.risk.toUpperCase()}</strong> · Time Sensitivity:{" "}
              <strong>{alert.urgency.toUpperCase()}</strong>
            </div>
          </div>
        );
      })}
    </div>
  );
}
